var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50292 3.74999C10.7155 3.74999 11.8289 4.16513 12.7176 4.85553L15.4455 2.25306C13.8595 0.854963 11.7834 0 9.50292 0C6.04723 0 3.05044 1.94993 1.5423 4.80737L4.57561 7.20207C5.31041 5.18951 7.23604 3.74999 9.50292 3.74999Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4209 10.1266C18.4678 9.75788 18.4988 9.38174 18.4988 9.00024C18.4988 8.35685 18.4286 7.73036 18.3003 7.12524H9.49887V10.8752H14.3635C13.97 11.8981 13.2693 12.7635 12.3774 13.3648L15.4219 15.7684C17.0359 14.3518 18.1403 12.368 18.4209 10.1266Z",
    fill: "#2196F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24999 9.00019C4.24999 8.3676 4.36763 7.76391 4.57266 7.20228L1.53935 4.80759C0.878249 6.06021 0.5 7.48531 0.5 9.00019C0.5 10.4981 0.871291 11.9074 1.51866 13.1499L4.55582 10.7521C4.36132 10.2035 4.24999 9.61551 4.24999 9.00019Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50182 14.2501C7.21768 14.2501 5.27965 12.7888 4.55767 10.7521L1.52051 13.1499C3.02128 16.0302 6.02919 18.0001 9.50182 18.0001C11.7726 18.0001 13.8434 17.1565 15.4249 15.7684L12.3803 13.3647C11.5577 13.9193 10.5731 14.2501 9.50182 14.2501Z",
    fill: "#00B060"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.50073 17.8126C6.85198 17.8126 4.47029 16.7198 2.78641 14.9786C4.43476 16.8285 6.82808 18.0001 9.50073 18.0001C12.1487 18.0001 14.5222 16.8516 16.1668 15.0307C14.4879 16.7436 12.1243 17.8126 9.50073 17.8126Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M9.49887 10.687V10.8745H14.3635L14.4395 10.687H9.49887Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4955 9.10983C18.4961 9.07289 18.4997 9.03659 18.4997 8.99956C18.4997 8.98907 18.498 8.97896 18.498 8.96848C18.4975 9.01572 18.4951 9.06241 18.4955 9.10983Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.49887 7.12524V7.31274H18.338C18.3262 7.25085 18.3133 7.18668 18.3003 7.12524H9.49887Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3014 7.12498H9.49997V10.875H14.3646C13.6081 12.8411 11.7328 14.25 9.49997 14.25C6.60051 14.25 4.24999 11.8994 4.24999 8.99997C4.24999 6.10046 6.60051 3.74999 9.49997 3.74999C10.5514 3.74999 11.5204 4.07299 12.3413 4.6055C12.467 4.68716 12.5966 4.76384 12.7147 4.85553L15.4425 2.25306L15.381 2.20573C13.8027 0.837796 11.7526 0 9.49997 0C4.52941 0 0.5 4.02941 0.5 8.99997C0.5 13.9705 4.52941 17.9999 9.49997 17.9999C14.0882 17.9999 17.8665 14.564 18.422 10.1263C18.4689 9.75761 18.4999 9.38147 18.4999 8.99997C18.4999 8.35659 18.4297 7.73009 18.3014 7.12498Z",
    fill: "url(#paint0_linear_91_7045)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.3432 4.41781C11.5222 3.88529 10.5532 3.5623 9.50182 3.5623C6.60235 3.5623 4.25183 5.91277 4.25183 8.81228C4.25183 8.84391 4.25226 8.86863 4.25281 8.90017C4.30339 6.04442 6.63398 3.7498 9.50182 3.7498C10.5532 3.7498 11.5222 4.07279 12.3432 4.60531C12.4688 4.68697 12.5985 4.76365 12.7165 4.85534L15.4444 2.25287L12.7165 4.66784C12.5985 4.57615 12.4688 4.49947 12.3432 4.41781Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.49997 0.187499C11.7312 0.187499 13.7622 1.01129 15.3344 2.35619L15.4425 2.25306L15.36 2.1812C13.7817 0.813267 11.7526 0 9.49997 0C4.52941 0 0.5 4.02941 0.5 8.99997C0.5 9.0316 0.504395 9.06214 0.504715 9.09372C0.555527 4.16687 4.56104 0.187499 9.49997 0.187499Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_7045",
    x1: 0.5,
    y1: 8.99997,
    x2: 18.4999,
    y2: 8.99997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogin);
export default __webpack_public_path__ + "static/media/google_login.0f4e11b844c913e4364aeff805a176a7.svg";
export { ForwardRef as ReactComponent };